export default "__VITE_ASSET__BtvpzZPO__"